import {
  Button,
  Flex,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import {
  DEFAULT_PROPERTY_IMAGE_URL,
  getPropertySource,
} from '~/apps/consumer/utils/listing.utils';
import { UserAvatar } from '../../User/UserAvatar';
import { useBuyerOfferAnalysisContext } from '../Context/BuyerOfferAnalysisContext';
import { BuyerInfo } from '../LeftSidebar/BuyerInfo';
import { ListingInfo } from '../LeftSidebar/ListingInfo';

export const BuyerAndListingInfo = () => {
  const { buyerOfferAnalysis, headerHeight } = useBuyerOfferAnalysisContext();

  const party = buyerOfferAnalysis?.party;
  const buyer = party?.primaryConsumer;
  const listing = buyerOfferAnalysis?.listing;

  return (
    <Flex
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRightWidth={0}
      height="90px"
      mt={headerHeight}
      width="100%"
    >
      <Flex
        borderRight="1px solid"
        borderRightColor="whiteAlpha.100"
        direction="column"
        flexBasis={0}
        flexGrow={1}
        gap={2}
        p={3}
      >
        <Text
          color="whiteAlpha.600"
          fontSize="xs"
          fontWeight="medium"
          textTransform="uppercase"
        >
          Buyer
        </Text>
        <Flex gap={2}>
          <UserAvatar
            size="sm"
            user={{
              fullName: buyer?.fullName,
              profilePicture: buyer?.profilePicture,
            }}
          />
          <Flex
            alignItems="flex-start"
            data-testid="mobile-buyer-info"
            direction="column"
            minWidth="0"
            width="100%"
          >
            <Text
              color="white"
              data-testid="mobile-buyer-name"
              fontSize="sm"
              fontWeight="medium"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="100%"
            >
              {buyer?.fullName}
            </Text>
            <BuyerInfoPopover />
          </Flex>
        </Flex>
      </Flex>
      <Flex direction="column" flexBasis={0} flexGrow={1} gap={2} p={3}>
        <Text
          color="whiteAlpha.600"
          data-testid="mobile-listing-info"
          fontSize="xs"
          fontWeight="medium"
          textTransform="uppercase"
        >
          Interested Home
        </Text>
        <Flex gap={2}>
          <Image
            borderRadius="xs"
            fallbackSrc={DEFAULT_PROPERTY_IMAGE_URL}
            height="30px"
            src={getPropertySource(listing?.mlsListing?.photos[0])}
            width="50px"
          />
          <Flex
            alignItems="flex-start"
            direction="column"
            minWidth="0"
            width="100%"
          >
            <Text
              color="white"
              fontSize="sm"
              fontWeight="medium"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="100%"
            >
              {listing?.mlsListing?.address.full}
            </Text>
            <ListingInfoPopover />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

const BuyerInfoPopover = () => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          color="whiteAlpha.600"
          data-testid="buyer-info-popover-trigger"
          size="xs"
          textDecoration="underline"
          variant="link"
        >
          Details
        </Button>
      </PopoverTrigger>
      <PopoverContent bg="bg.mainDark">
        <PopoverArrow bg="bg.mainDark" />
        <PopoverBody>
          <BuyerInfo />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

const ListingInfoPopover = () => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          color="whiteAlpha.600"
          data-testid="listing-info-popover-trigger"
          size="xs"
          textDecoration="underline"
          variant="link"
        >
          Details
        </Button>
      </PopoverTrigger>
      <PopoverContent bg="bg.mainDark">
        <PopoverArrow bg="bg.mainDark" />
        <PopoverBody>
          <ListingInfo />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
